import { GridActionsCellItem, type GridRowParams } from "@mui/x-data-grid";
import EditIcon from '@mui/icons-material/Edit';
import type { WaMessageSetup } from "features/waMessaging/types";
import { useWaMessageSetupContext } from "./WaMessageSetupProvider";

const useRowActions = () => {
    const { openEdit } = useWaMessageSetupContext();

    return ({ row }: GridRowParams<WaMessageSetup>) => [
        <GridActionsCellItem
            key='edit'
            onClick={() => openEdit(row)}
            icon={<EditIcon />}
            label='Edit'
            data-test-id={`waMessagesSetups.table.row.${row.coreId}.actions.edit`}
        />
    ];
};

export default useRowActions;
